// extracted by mini-css-extract-plugin
module.exports = {"efaxOrdersLabel":"InboxSidebar_efaxOrdersLabel__3_yhh","unassignedEfaxes":"InboxSidebar_unassignedEfaxes__HYQZe"};